import useSEO from "@/components/site/useSEO";
import PageHero from "@/components/site/PageHero";
import { ScreenBlock, CTABand, SectionHead } from "@/components/site/ui";
import { RotaScreen } from "@/components/site/mockups";

const IMG = "https://images.unsplash.com/photo-1658314755707-1fbdf7c40145?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function DomiciliaryCare() {
  useSEO(
    "Domiciliary Care Software | AYOBELL Home Care Management",
    "AYOBELL helps home care providers manage visits, rota, care records, medication, attendance and governance — with operational visibility across community-based services."
  );
  return (
    <>
      <PageHero
        eyebrow="Domiciliary Care"
        title="From scheduling to care delivery — stay connected."
        subtitle="AYOBELL keeps community-based services connected: plan visits and rota, record care and medication, and keep clear visibility across your operation."
        primary={{ to: "/contact", label: "Book a Demo" }}
        secondary={{ to: "/platform", label: "Explore the Platform" }}
        screenKey="rota"
        screenComp={RotaScreen}
      />

      <section className="bg-white py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden h-64 sm:h-80">
            <img src={IMG} alt="Home care worker supporting a person in their own home" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
          </div>
        </div>
      </section>

      <section className="bg-slate-50 py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <ScreenBlock
            eyebrow="Visits & scheduling"
            title="Plan visits and rota with confidence"
            desc="Schedule visits and shifts across your team, and keep attendance clear so you know care is being delivered."
            points={["Visits & shift management", "Staff rota", "Attendance", "Appointments"]}
            screenKey="rota"
          />
        </div>
      </section>

      <section className="bg-white py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <ScreenBlock
            reverse
            eyebrow="Care records & medication"
            title="Care records and medication in the community"
            desc="Record care as it's delivered and keep medication records organised for people supported in their own homes."
            points={["Care records & daily notes", "Medication records & MAR / eMAR", "PRN medication", "Alerts & risks"]}
            screenKey="careplans"
          />
        </div>
      </section>

      <section className="bg-slate-50 py-20 sm:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <SectionHead center eyebrow="Oversight" title="Operational visibility and governance" desc="Understand staffing and performance across community-based services, and keep governance evidence together." />
          <div className="mt-14">
            <ScreenBlock
              reverse
              title="A clear operational picture"
              desc="Dashboards summarise staffing and operations, while governance tools keep incidents, safeguarding and readiness indicators in view."
              points={["Staff oversight", "Operational summaries & dashboards", "Incidents & safeguarding", "AYOBELL CQC readiness dashboard"]}
              screenKey="dashboard"
            />
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
